import { render, staticRenderFns } from "./DeviceAlertEditDialog.vue?vue&type=template&id=2cb93014&scoped=true"
import script from "./DeviceAlertEditDialog.vue?vue&type=script&lang=ts"
export * from "./DeviceAlertEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./DeviceAlertEditDialog.vue?vue&type=style&index=0&id=2cb93014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb93014",
  null
  
)

export default component.exports